export enum SELECTOR {
  MAIN_WRAPPER = 'main-wrapper',
  PAGE_NAV_WRAPPER = 'page-nav-wrapper',
}
